const map = {
    javascript: {
        type: 'JavaScript',
        support: true,
        filename: '.js',
        option: 'javascript',
    },
    python: {
        type: 'Python',
        support: false,
        filename: '.py',
        option: 'python',
    },
    markdown: {
        type: 'Markdown',
        support: false,
        filename: '.md',
        option: 'markdown',
    },
    typescript: {
        type: 'TypeScript',
        support: true,
        filename: '.ts',
        option: 'typescript',
    },
    'c++': {
        type: 'C++',
        support: false,
        filename: '.cpp',
        option: 'c++',
    },
    html: {
        type: 'HTML',
        support: true,
        filename: '.html',
        option: 'html',
    },
    css: {
        type: 'CSS',
        support: true,
        filename: '.css',
        option: 'css',
    },
    less: {
        type: 'LESS',
        support: true,
        filename: '.less',
        option: 'less',
    },
    scss: {
        type: 'SCSS',
        support: true,
        filename: '.scss',
        option: 'scss',
    },
    json: {
        type: 'JSON',
        support: true,
        filename: '.json',
        option: 'json',
    },
    xml: {
        type: 'XML',
        support: false,
        filename: '.xml',
        option: 'xml',
    },
    php: {
        type: 'PHP',
        support: false,
        filename: '.php',
        option: 'php',
    },
    'c#': {
        type: 'C#',
        support: false,
        filename: '.cs',
        option: 'c#',
    },
    razor: {
        type: 'RAZOR',
        support: false,
        filename: '.razor',
        option: 'razor',
    },
    diff: {
        type: 'DIFF',
        support: false,
        filename: '.diff',
        option: 'diff',
    },
    java: {
        type: 'Java',
        support: false,
        filename: '.java',
        option: 'java',
    },
    vb: {
        type: 'VB',
        support: false,
        filename: '.vb',
        option: 'vb',
    },
    coffeescript: {
        type: 'CoffeeScript',
        support: false,
        filename: '.coffee',
        option: 'coffeescript',
    },
    handlebars: {
        type: 'Handlebars',
        support: false,
        filename: '.hbs',
        option: 'handlebars',
    },
    batch: {
        type: 'Batch',
        support: false,
        filename: '.sh',
        option: 'batch',
    },
    pug: {
        type: 'Pug',
        support: false,
        filename: '.pug',
        option: 'pug',
    },
    'f#': {
        type: 'F#',
        support: false,
        filename: '.fs',
        option: 'f#',
    },
    lua: {
        type: 'Lua',
        support: false,
        filename: '.lua',
        option: 'lua',
    },
    powershell: {
        type: 'PowerShell',
        support: false,
        filename: '.ps1',
        option: 'powershell',
    },
    ruby: {
        type: 'Ruby',
        support: false,
        filename: '.rb',
        option: 'ruby',
    },
    sass: {
        type: 'SASS',
        support: false,
        filename: '.sass',
        option: 'sass',
    },
    r: {
        type: 'R',
        support: false,
        filename: '.r',
        option: 'r',
    },
};

export { map }